import React from 'react';
import SearchLinkList from '../platformui/SearchLinkList';

const SearchLinkListBlock = (props) => <SearchLinkList {...props} />;

export default SearchLinkListBlock;
